import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-location-data-v2',
    templateUrl: './location-data-v2.component.html',
    styleUrls: ['./location-data-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LocationDataV2Component implements OnInit {

  constructor() { }
  @Input() locationData;
  @Input() configData;

  verificationDestLocData;

  officeHours = [];
  loadingHours = [];

  ngOnInit() {        
    this.fetchLocation(this.locationData);    
  }  

  fetchLocation(data){
    let location;
    location = localStorage.getItem(data.name); 

    location = location? JSON.parse(location): '';
    this.locationData = location;

    if(this.locationData.hoursOperations){
      let order = { sun: 1, mon: 2, tue: 3, wed: 4, thu: 5, fri: 6, sat: 7 };

      Object.keys(this.locationData.hoursOperations.officeHours).forEach(dataKey=>{
        let obj = {};
        obj['key'] = dataKey.substring(0,3);
        obj['closed'] = !this.locationData.hoursOperations.officeHours[dataKey].isPresent;
        if(this.locationData.hoursOperations.officeHours[dataKey].to){
          obj['value'] = [this.locationData.hoursOperations.officeHours[dataKey].from,
          this.locationData.hoursOperations.officeHours[dataKey].to].join(" : ");  
        } else{
          obj['value'] = this.locationData.hoursOperations.officeHours[dataKey].from;
        }      
        this.officeHours.push(obj);
      })
      Object.keys(this.locationData.hoursOperations.loadingHours).forEach(dataKey=>{
        let obj = {};
        obj['key'] = dataKey.substring(0,3);
        obj['closed'] = !this.locationData.hoursOperations.loadingHours[dataKey].isPresent;
        if(this.locationData.hoursOperations.loadingHours[dataKey].to){
          obj['value'] = [this.locationData.hoursOperations.loadingHours[dataKey].from,
          this.locationData.hoursOperations.loadingHours[dataKey].to].join(" : ");  
        } else{
          obj['value'] = this.locationData.hoursOperations.loadingHours[dataKey].from;
        }
        this.loadingHours.push(obj);
      })
      this.loadingHours.sort(function(a,b){
        return order[a.key] - order[b.key];
      });
      this.officeHours.sort(function(a,b){
        return order[a.key] - order[b.key];
      });
    } 
    if(this.locationData){
      this.locationData['_24HourCall'] = this.locationData['24HourCall'];
    }    
  }

}
